// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tabinputs_wrapper__35roa","inputs":"tabinputs_inputs__1Yl7f","options":"tabinputs_options__2Rr6c"};